import React from 'react'
import './PageHeader.scss'

const PageHeader = (props) => (
  <div className='pan-page-header page-header flex-wrap'>
    <h1 className='mb-2'>{props.head}</h1>
    {props.buttons && (
      <div className='ml-auto'>{props.buttons}</div>
    )}
    <div className='break'/>
    <div style={{ fontSize: 17, color: '#999' }} className={props.subheadClassName}>{props.subhead}</div>
  </div>
)

export default PageHeader
